import { createContext } from "../../__compat__/react/main.entry.mjs.mjs";
export const TableContext = createContext({
    displayMode: 'auto',
});
TableContext.displayName = 'TableContext';
//# sourceMappingURL=Table.context.mjs.mjs.map